"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/Header.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _types = require('web/screens/Directory/types');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');

var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _Add = require('web/components/Add'); var _Add2 = _interopRequireDefault(_Add);
var _OrgPicker = require('./OrgPicker'); var _OrgPicker2 = _interopRequireDefault(_OrgPicker);
var _DirectoryCreateNewModal = require('web/screens/Directory/DirectoryCreateNewModal'); var _DirectoryCreateNewModal2 = _interopRequireDefault(_DirectoryCreateNewModal);









/* The Directory's header, the inbox's (Directory redesign, #1173): the people
 * tile, "Directory" and the org (OrgPicker), then the + button, with the create
 * dialog it opens. The sidebar shows it above the Coworkers and Teams lists,
 * and the patient table across the full width, with its import button left of
 * the + (D-97). */
const DirectoryHeader = ({ orgKey, selectedTab, onRequestPatientsFeature, beforeAdd }) => {
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => !!(orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey)))
  const hasAnyActiveOrgs = _hooks.useAppSelector.call(void 0, _user.selectHasAnyActiveOrgs)
  const hasPatientsFeature = _hooks.useAppSelector.call(void 0, 
    state => !!(orgKey && _org.selectOrgHasPatientMessagingFeature.call(void 0, state, orgKey)),
  )

  const {
    isOpen: isCreateNewModalOpen,
    onOpen: onOpenCreateNewModal,
    onClose: onCloseCreateNewModal,
  } = _useToggle2.default.call(void 0, )

  const resolveAddHandler = () => {
    if (
      !hasAnyActiveOrgs
      || (!amIAdmin && selectedTab === _types.DirectoryTab.TEAMS)
    ) return null

    if (!hasPatientsFeature && selectedTab === _types.DirectoryTab.PATIENTS) {
      return amIAdmin ? onRequestPatientsFeature : null
    }

    return onOpenCreateNewModal
  }

  const onAddPress = resolveAddHandler()
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_DirectoryCreateNewModal2.default, {
        isOpen: isCreateNewModalOpen,
        onClose: onCloseCreateNewModal,
        directoryTypeHint: selectedTab,
        orgKeyContext: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      )
      , _react2.default.createElement('div', { className: "inbox-list-header directory-header" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
        , _react2.default.createElement(_OrgPicker2.default, { selectedOrgKey: orgKey, onSelectOrg: _actions2.default.setSelectedOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}} )
        ,  beforeAdd 
        ,  onAddPress && _react2.default.createElement(_Add2.default, { onClick: onAddPress, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} ) 
      )
    )
  )
}

exports. default = _react.memo.call(void 0, DirectoryHeader)
